import { render, staticRenderFns } from "./brandLine.vue?vue&type=template&id=5b2be5f2&scoped=true"
import script from "./brandLine.vue?vue&type=script&lang=js"
export * from "./brandLine.vue?vue&type=script&lang=js"
import style0 from "./brandLine.vue?vue&type=style&index=0&id=5b2be5f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2be5f2",
  null
  
)

export default component.exports